import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(undefined);

  useEffect(() => {
    const load = async () => {
      if (!localStorage.getItem("sijil_token")) {
        setUser(null);
        return;
      }
      try {
        const { data } = await api.get("/auth/me");
        setUser(data);
      } catch {
        localStorage.removeItem("sijil_token");
        setUser(null);
      }
    };
    load();
  }, []);

  const login = async (username, password) => {
    const { data } = await api.post("/auth/login", { username, password });
    localStorage.setItem("sijil_token", data.token);
    setUser(data);
    return data;
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch {}
    localStorage.removeItem("sijil_token");
    setUser(null);
  };

  const can = (perm) => user?.role === "admin" || Boolean(user?.permissions?.[perm]);

  return (
    <AuthContext.Provider value={{ user, setUser, login, logout, can }}>
      {children}
    </AuthContext.Provider>
  );
};
